<template>
  <!--  {{this.items}}-->
  <el-form label-width="100px" class="app">
    <el-form-item label="薪资项目：">
      <el-input v-model="name" style="width: 90%" placeholder="夜班补贴&餐补" disabled/>
    </el-form-item>
    <el-form-item label="备注：">
      <el-input v-model="remark" style="width: 90%" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea"
                maxlength="64"
      />
    </el-form-item>
    <h4 style="margin-left: 20px">发放规则：</h4>
    <el-form class="bordered-container">
      <el-table :data="items" style="width: 95%" :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column label="序号" type="index" width="80"></el-table-column>
        <el-table-column prop="condition" label="条件" width="150"></el-table-column>
        <el-table-column prop="duration" label="时长">
          <template v-slot="scope">
            <el-input v-model="scope.row.duration" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="餐补金额">
          <template v-slot="scope">
            <el-input v-model="scope.row.amount" type="number"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div style="margin-top: 7%;text-align: center ">
      <el-button type="primary" @click="saveButton">保存</el-button>
    </div>
  </el-form>
</template>
<script>
export default {
  name: "MealAllowance",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      radiusGroup: [],
      remark: '',
      items: [
        {condition: 'B班正班时长≥', duration: '', amount: ''},
        {condition: 'B班加班时长≥', duration: '', amount: ''}
      ],
    }
  },

  methods: {
    async saveButton() {
      for (let item of this.items) {
        if (item.duration === '' || item.amount === '') {
          this.$message({
            message: "发放规则不能为空！",
            type: "error",
          });
          return;
        }
        if (Number(item.duration) < 0 || Number(item.amount) < 0) {
          this.$message({
            message: "发放规则不能为负数！",
            type: "error",
          });
          return;
        }
      }
      let pageId = {
        id: this.parentData.id
      }
      let params = {
        items: this.items,
        remark: this.remark,
        itemId: pageId.id
      }
      await this.$http("salaryRuleConfigureService.saveMealAllowance", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("salaryRuleConfigureService.getMealAllowanceById", params);
        this.items[0].duration = data.working_hours
        this.items[0].amount = data.working_amount
        this.items[1].duration = data.overtime_hours
        this.items[1].amount = data.overtime_amount
        this.remark = data.remark
      }
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped lang="less">

.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: 18px;
  margin: 10px 0;
}

.bordered-container {
  border: 0.5px solid lightgrey;
  padding: 10px 20px 45px 20px;
  width: 98%;
  margin: 10px;
}

.app {
  margin: 20px;
}
</style>